import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-confirm-for-upgrade-to-business',
  templateUrl: './confirm-for-upgrade-to-business.component.html',
  styleUrls: ['./confirm-for-upgrade-to-business.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
})
export class ConfirmForUpgradeToBusinessComponent implements OnInit {
  constructor(public modalController: ModalController) {}

  ngOnInit() {}

  async dismiss(data: any) {
    this.modalController.dismiss(data);
  }
}
